import type { CompanyLegalStatus, InsolvencySummary } from '@/lib/backend-api';

export function resolveLegalStatus(
  insolvencySummary: InsolvencySummary | null,
): CompanyLegalStatus {
  return (
    insolvencySummary?.status ??
    (insolvencySummary?.company_status === 'insolvent'
      ? 'insolvent'
      : insolvencySummary?.dissolved === true
        ? 'in_liquidation'
        : 'active')
  );
}
